// countSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import http from "../services/httpService";
import { getWorkInstructions } from "../services/workinstructions";
import { getActions } from "../services/forumcategories";
import { getUsers } from "../services/users";
import { getTickets } from "../services/tickets";

const slice = createSlice({
    name: "count",
    initialState: {
        ticketCount: 0,
        userCount: 0,
        forumCount: 0,
        workInstructionCount: 0,
        loading: false,
        error: null,
    },
    reducers: {
        // Set individual counts
        setTicketCount: (state, action) => {
            state.ticketCount = action.payload;
        },
        setUserCount: (state, action) => {
            state.userCount = action.payload;
        },
        setForumCount: (state, action) => {
            state.forumCount = action.payload;
        },
        setWorkInstructionCount: (state, action) => {
            state.workInstructionCount = action.payload;
        },

        // Set loading state
        countsLoading: (state) => {
            state.loading = true;
        },

        // Set error
        countsError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    setTicketCount,
    setUserCount,
    setForumCount,
    setWorkInstructionCount,
    countsLoading,
    countsError,
} = slice.actions;
export default slice.reducer;

export const fetchTicketCount = () => async (dispatch) => {
    dispatch(countsLoading());

    try {
        const response = await getTickets();
        const ticketCount = response.data.length;
        dispatch(setTicketCount(ticketCount));
    } catch (error) {
        dispatch(countsError(error.message));
    }
};

export const fetchUserCount = () => async (dispatch) => {
    dispatch(countsLoading());

    try {
        const response = await getUsers();
        const userCount = response.data.length;
        dispatch(setUserCount(userCount));
    } catch (error) {
        dispatch(countsError(error.message));
    }
};

export const fetchForumCount = () => async (dispatch) => {
    dispatch(countsLoading());

    try {
        const response = await getActions();
        const forumCount = response.data.length;
        dispatch(setForumCount(forumCount));
    } catch (error) {
        dispatch(countsError(error.message));
    }
};

export const fetchWorkInstructionCount = () => async (dispatch) => {
    dispatch(countsLoading());

    try {
        const response = await getWorkInstructions();
        const instCount = response.data.length;
        dispatch(setWorkInstructionCount(instCount));
    } catch (error) {
        dispatch(countsError(error.message));
    }
};